import { ReferenceFields } from 'honeygrid-types'

import type { HoneygridAPIH3CellProperties } from 'honeygrid-types'

const usdFormatter = Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
})

export const formatDemographics = (cell: HoneygridAPIH3CellProperties) => {
	const sales = cell[ReferenceFields.CustomerSales]
	const homeValues = cell[ReferenceFields.HomeValues]
	const homeValuesUSD = homeValues ? usdFormatter.format(homeValues) : null
	const marketShare = cell[ReferenceFields.CustomerMarketShare]
		? `${(cell[ReferenceFields.CustomerMarketShare] * 100).toFixed(2)}%`
		: null

	const households = cell[ReferenceFields.Households]
		? Math.floor(cell[ReferenceFields.Households])
		: null
	const income = cell[ReferenceFields.Income]
	const sfdu = cell[ReferenceFields.SFDU] ? Math.floor(cell[ReferenceFields.SFDU]) : null
	const mfdu = cell[ReferenceFields.MFDU] ? Math.floor(cell[ReferenceFields.MFDU]) : null
	const newMovers = cell[ReferenceFields.NewMoverTotal]
		? Math.floor(cell[ReferenceFields.NewMoverTotal])
		: null

	return {
		customerCount: cell[ReferenceFields.CustomerCount],
		sales,
		homeValues,
		homeValuesUSD,
		marketShare,
		households,
		income,
		sfdu,
		mfdu,
		newMovers,
	}
}
